import './assets/common.less';
import './assets/index.less';
$(document).ready(function () {
         var page=1;
           
            $("#loadMore").click(function () {
                page++;
                $.ajax({
                    type: "GET", 
                    url: window.location.origin+"/info/api/list",//"http://lingxi.aliyun.test:8001/info/api/list",
                    data: { page: page }, 
                    success: function (response) { 
                        var dom = ''; 
                        response.data.forEach(element => {
                            dom += `<div class="content">
                <a target="_blank" href=${window.location.origin+'/info/detail/'+element.aid}>
                        <img src="https://img.alicdn.com/tfs/TB1jOL3oAyWBuNjy0FpXXassXXa-400-240.png" alt="" class="preloadImg">
                        <img src=${element.firstImg} alt="" class="realImg" onload="handleOnload.call(this)">
                 
                </a>
                <p class='title'>
                    <a target="_blank" href=${window.location.origin+'/info/detail/'+element.aid}>${element.title}</a>
                </p>
                <p class='summary'>
                    ${element.abstractContent}
                </p>
                <div class="info">
                    <span style="float: left;">${element.blogUserVO.nickName} · ${element.ctime}</span>

                    <span style="float: right;">${element.hitCount}人浏览</span>  
                </div>
            </div>`  
                        });
                        $('.listContainer').append(dom)
                        
                        console.log(page,'==============')
                    },
                    error: function (msg) {
                        console.log(msg, 'msg=======')
                    }
                });
            });
        });


// WEBPACK FOOTER //
// ./src/index.js